var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { UnstyledButton } from '../Buttons';
import { Icon } from '../Icon';
const ButtonContainer = styled(UnstyledButton) `
  display: flex;
  justify-content: center;
  width: 100%;
`;
const StyledIcon = styled((_a) => {
    var { shouldImageFlip } = _a, others = __rest(_a, ["shouldImageFlip"]);
    return React.createElement(Icon, Object.assign({}, others));
}) `
  transform: ${({ shouldImageFlip }) => (shouldImageFlip ? 'scale(-1, -1)' : 'none')};
  color: ${({ theme }) => theme.primaryRed};
  font-size: 35px;
  margin-bottom: 10px;
`;
export const ToggleFooter = ({ isOpen, onToggle }) => {
    return (React.createElement(ButtonContainer, { onClick: onToggle },
        React.createElement(StyledIcon, { shouldImageFlip: isOpen }, "arrow_drop_down")));
};
